import { render, staticRenderFns } from "./Sconti.vue?vue&type=template&id=49dd1b22"
import script from "./Sconti.vue?vue&type=script&lang=js"
export * from "./Sconti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports